/**
 * Helpers for working with Updater's CMS.
 *
 * ### Differences between `cjs` and `es` builds:
 *
 * - `syncToDisk` is not included in the `es` build due to the fact that it will
 *   not function in the browser.
 * - `createFullTextNode` is not included in the `cjs` build due to the fact
 *   that it will not function in node.
 *
 * As a result if you are bundling this for a browser make sure to use the
 * `module` build instead of the `main` build. If your bundler doesn't
 * automatically prefer `module` you can import it with:
 *
 * ```javascript
 * import ... from '@updater-components/contentful/index.module.js'
 * ```
 *
 * @module contentful
 */

import { getClient } from './client';
import { sync } from './sync';

export { getClient, sync };
